import React from 'react';
import {useSelector} from "react-redux";
import MultiEntityWrapper from "../MultiEntityWrapper";
import BreachRiskTechnicalPage from "../../../brbusiness/routes/TechData/TechData"
import {bbFindEntityWithinPortfolioOrSelf} from "../../../../../util/bbHelpers";

const Dashboard= (props) => {

    const {customerInView} = useSelector(({customer}) => customer);
    // const customer = customers ? customers[customerInView] : null;

    const {entityInView, portfolios} = useSelector(({breachrisk}) => breachrisk);

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerInView);

    return (
        <MultiEntityWrapper entity={myEntity}>
            <BreachRiskTechnicalPage portfolioView/>
        </MultiEntityWrapper>
    )
}
export default Dashboard;